// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_FINANCIAMENTO_ORIGEM = {
  Divida: 'FIN_FINANCIAMENTO_ORIGEM1',
  Recebiveis: 'FIN_FINANCIAMENTO_ORIGEM2',
  Direto: 'FIN_FINANCIAMENTO_ORIGEM3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_FINANCIAMENTO_ORIGEM1: 1,
    FIN_FINANCIAMENTO_ORIGEM2: 2,
    FIN_FINANCIAMENTO_ORIGEM3: 3
  }
}
